import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_APP_ENVIRONMENT,
  debug: false,
  enabled: process.env.REACT_APP_APP_ENVIRONMENT !== 'local',
  integrations: [],
});
